module.exports = __webpack_public_path__ + "img/v1.7.bade016c.jpg";